var exports = {
  "E6": "ChannelEmbed.module__embed___TXAtR1",
  "vO": "ChannelEmbed.module__embedFull___TXAtR1",
  "UT": "ChannelEmbed.module__gridContainer___TXAtR1",
  "Vg": "ChannelEmbed.module__grid___TXAtR1",
  "$H": "ChannelEmbed.module__hasThumbnail___TXAtR1",
  "zE": "ChannelEmbed.module__embedContent___TXAtR1",
  "Cj": "ChannelEmbed.module__embedLink___TXAtR1",
  "zC": "ChannelEmbed.module__embedProvider___TXAtR1",
  "rN": "ChannelEmbed.module__embedAuthor___TXAtR1",
  "QQ": "ChannelEmbed.module__embedAuthorName___TXAtR1",
  "av": "ChannelEmbed.module__embedAuthorNameLink___TXAtR1",
  "SG": "ChannelEmbed.module__embedAuthorIcon___TXAtR1",
  "gt": "ChannelEmbed.module__embedTitle___TXAtR1",
  "cD": "ChannelEmbed.module__embedDescription___TXAtR1",
  "j0": "ChannelEmbed.module__embedFields___TXAtR1",
  "Me": "ChannelEmbed.module__embedField___TXAtR1",
  "$L": "ChannelEmbed.module__embedFieldName___TXAtR1",
  "VN": "ChannelEmbed.module__embedFieldValue___TXAtR1",
  "oy": "ChannelEmbed.module__embedFooterText___TXAtR1",
  "W$": "ChannelEmbed.module__embedMedia___TXAtR1",
  "ad": "ChannelEmbed.module__embedThumbnail___TXAtR1",
  "te": "ChannelEmbed.module__embedFooter___TXAtR1",
  "mG": "ChannelEmbed.module__embedFooterIcon___TXAtR1",
  "i8": "ChannelEmbed.module__embedFooterSeparator___TXAtR1",
  "PN": "ChannelEmbed.module__embedGifvContainer___TXAtR1",
  "kL": "ChannelEmbed.module__container___TXAtR1",
  "mQ": "ChannelEmbed.module__mediaFrame___TXAtR1",
  "Mc": "ChannelEmbed.module__suppressButton___TXAtR1",
  "wJ": "ChannelEmbed.module__mediaSuppressButton___TXAtR1",
  "Fk": "ChannelEmbed.module__blueskyMediaEngagement___TXAtR1",
  "Uf": "ChannelEmbed.module__blueskyGalleryMedia___TXAtR1",
  "$j": "ChannelEmbed.module__blueskyEngagement___TXAtR1",
  "Z": "ChannelEmbed.module__blueskyNestedEmbedContainer___TXAtR1",
  "mx": "ChannelEmbed.module__blueskyNestedEmbed___TXAtR1",
  "gp": "ChannelEmbed.module__blueskyNestedMediaEngagement___TXAtR1",
  "qP": "ChannelEmbed.module__blueskyEngagementItem___TXAtR1",
};

module.exports = exports;
